import getScore from '@opsbase/lib-form/helpers/getScore';
import isValidAnswer from '@opsbase/lib-form/helpers/isValidAnswer';
import Palette from '@opsbase/lib-palette';
import FailIcon from '@opsbase/web-icons/icons/FailIcon';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Button from '@opsbase/web-ui/Button';
import React, { useContext } from 'react';
import useReportCSS from '../../useReportCSS';
import DetailsOpReportContext from './DetailsOpReportContext';
import { DetailsOpReportQuestionContext } from './DetailsOpReportQuestion';
export function DetailsOpReportAnswerCell({ children = null, right = false }) {
    const { op, def, form } = useContext(DetailsOpReportContext);
    const { r, a, q } = useContext(DetailsOpReportQuestionContext);
    const myCss = useReportCSS(def.pdf);
    const { total } = getScore(form, q);
    // only checking validity because we are nulling the answer
    // for some conditions but the answers are still tere in the op :D
    const hasValidAnswer = isValidAnswer(a, q, r);
    const showScore = hasValidAnswer && op.isScoreEnabled && r.scoring;
    const showFail = hasValidAnswer && op.isScoreEnabled && a.fail;
    return (React.createElement("td", { className: myCss.data + (right ? ' ' + myCss.right : '') },
        React.createElement(Horizontal, { justify: 'flex-start', centered: true },
            children,
            React.createElement(Pane, { shrink: true, style: { marginLeft: 'auto' } },
                showFail && a.fail && (React.createElement(Button, { margin: "0 0 3px 8px", round: true, icon: React.createElement(FailIcon, { htmlColor: 'red' }), color: Palette.White })),
                showScore ? (React.createElement(Button, { small: true, margin: "3px 0 3px 8px", round: true, color: Palette.GoodOldBlue }, String(total))) : (React.createElement("div", { style: { width: 40 } }))))));
}
export default DetailsOpReportAnswerCell;
